/**
 * generer l'url vendor
 */
export function generateVendor(domain: string): string {
    return new URL("vendor/", domain).toString();
}